import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class ReportsFavoriteTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.REPORTS_FAVORITE;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLE_FAVORITE_REPORT;

	get id(): string {
		return TourId.REPORTS__FAVORITE;
	}

	override get keyForPersistantDone(): string {
		return ReportsFavoriteTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.DOWN,
				allowStacked: false,
				attachTo: () => {
					return this.el?.find('.favorite') || null;
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}

	override onExplicitClose(): void {
		this.el?.removeClass('card--show-overlay');
	}
}
